import { Flex, Text, Timeline, TimelineItem } from '@mantine/core';
import { IconCircleCheck, IconCircleX } from '@tabler/icons-react';
import { Submission } from 'interfaces';
import { formatDateTime } from 'utils/dateUtils';
import React from 'react';
import { ChangedByUser } from './ClaimHistoryTimeline';

interface SubmissionTimelineProps {
  data: Submission[];
  isLoading: boolean;
  isError: boolean;
  errorMessage: string;
}

export const SubmissionTimeline: React.FC<SubmissionTimelineProps> = ({
  data,
}) => {
  return (
    <Timeline>
      {data.map((submission) => (
        <TimelineItem
          key={submission.id}
          radius="lg"
          title={<Text fw={'bold'}>{submission.filename}</Text>}
        >
          <Timeline>
            <Flex justify="space-between" align="center" mb="xs">
              <Text fw="bold">Submitted by:</Text>
              <ChangedByUser cognitoID={submission.cognitoID} />
            </Flex>

            <Flex justify="space-between" align="center" mb="xs">
              <Text fw="bold">Submitted at:</Text>
              <Text>{formatDateTime(submission.submittedAt)}</Text>
            </Flex>

            <Flex justify="space-between" align="center" mb="xs">
              <Text fw="bold">Status:</Text>
              <Text>{submission.status}</Text>
            </Flex>

            <Flex justify="space-between" align="center" mb="xs">
              <Text fw="bold">Uploaded:</Text>
              {submission.uploaded ? (
                <IconCircleCheck color="green" />
              ) : (
                <IconCircleX color="red" />
              )}
            </Flex>

            <Flex justify="space-between" align="center">
              <Text fw="bold">Starting Claim #:</Text>
              <Text>{submission.startingClaim}</Text>
            </Flex>
          </Timeline>
        </TimelineItem>
      ))}
    </Timeline>
  );
};
